import React from "react";

import ParkaPrimoAussenjacke from "../Garments/ParkaPrimoAussenjacke";

export default function ParkaPrimoAussenjackePage() {
  return <ParkaPrimoAussenjacke />;
}
